import { DropdownMenuManager } from "./menus/DropdownMenuManager.js";
import { BarMenuManager } from "./menus/BarMenuManager.js";
DropdownMenuManager.use();
BarMenuManager.use();
import { ToggleMenu } from "./actions/ToggleMenu.js";
ToggleMenu.use();
